import { PosProvider } from 'api/captureRate'

const POS_PROVIDER_LOGO_KEYS: Record<PosProvider, string> = {
  toast: 'toast',
  square: 'square',
  qu: 'qu',
  ncr: 'ncr',
  brink: 'par_brink',
  genius: 'genius_xenial',
}

export function posProviderLogoKey(provider: PosProvider): string {
  return POS_PROVIDER_LOGO_KEYS[provider]
}
